/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum SelectionInputType {
    EMBEDDINGS = 'EMBEDDINGS',
    SCORES = 'SCORES',
    METADATA = 'METADATA',
    PREDICTIONS = 'PREDICTIONS',
    RANDOM = 'RANDOM'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const SelectionInputTypeValidatorShape = [
    'EMBEDDINGS',
    'SCORES',
    'METADATA',
    'PREDICTIONS',
    'RANDOM'
];
export const SelectionInputTypeValidator = yup.mixed().oneOf(SelectionInputTypeValidatorShape);
export const SelectionInputTypeStringifyShapeProperties = {};
export const SelectionInputTypeStringifyShape: StringSchema = {
    title: 'SelectionInputType Stringifier',
    type: 'string'
};
export const SelectionInputTypeStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(SelectionInputTypeStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function SelectionInputTypeFromJSON(json: any): SelectionInputType {
    return SelectionInputTypeFromJSONTyped(json, false);
}
export function SelectionInputTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectionInputType {
    return json as SelectionInputType;
}
export function SelectionInputTypeToJSON(value?: SelectionInputType | null): any {
    return value as any;
}
